import React from 'react';
import styled from '@emotion/styled';
import { Css, Responsive, Shimmer } from '../../../../../ui';
import SolicitationsProposersListRowShimmerMobile from './shimmer/SolicitationsProposersListRowShimmerMobile';
import SolicitationProposersListRowShimmer from './shimmer/SolicitationProposersListRowShimmer';
import { StyledProposerRowsMobile } from './SolicitationProposersListRowMobile';

export default function SolicitationProposersListShimmer() {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');
	const items = [...Array(6)];

	return (
		<StyledShimmer>
			{items.map((_, index) =>
				isMobileXL ? (
					<SolicitationsProposersListRowShimmerMobile
						// eslint-disable-next-line react/no-array-index-key
						key={`shimmer-${index}`}
					/>
				) : (
					// eslint-disable-next-line react/no-array-index-key
					<SolicitationProposersListRowShimmer key={`shimmer-${index}`} />
				),
			)}
		</StyledShimmer>
	);
}

const StyledShimmer = styled(Shimmer)`
	margin-bottom: ${Css.pxToRem(100)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${StyledProposerRowsMobile} {
			padding-top: 0;
		}
	}
`;
